import { memo } from "react";

import { QuestionOptionMaxStockNum as Question } from "@/components/features/items/edit/option/_shared/ui/components/max-stock-num";

import { useOptionMaxStockNum } from "./hooks";

export const QuestionOptionMaxStockNum = memo(() => {
	const { maxStockNum, onSetMaxStockNum, isEdited, hasError } = useOptionMaxStockNum();

	return (
		<Question
			maxStockNum={maxStockNum}
			onSetMaxStockNum={onSetMaxStockNum}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
});

QuestionOptionMaxStockNum.displayName = "QuestionOptionMaxStockNum";
